<template>
  <div class="audience-filter">
    <button class="button button-filter-selector" @click="toggleFilter()">
      <span class="icon is-small">
        <i class="material-icons">&#xE152;</i>
      </span>
      <span>{{ $t('audience.filter.title') }}</span>
      <span class="tag is-rounded" v-if="filtersCount > 0">{{ filtersCount }}</span>
      <span class="icon is-small">
        <i class="material-icons">{{ isFilterActive ? '&#xE316;' : '&#xE313;' }}</i>
      </span>
    </button>
    <div class="field has-addons field-user-search">
      <p class="control has-icons-left">
        <input
          class="input"
          type="text"
          :placeholder="$t('audience.filter.search_placeholder')"
          v-model="userId"
          @focus="onFocus()"
          @focusout="onFocusOut()"
          @keyup.enter="goToDetail()"
        >
        <span class="icon is-small is-left">
          <i class="material-icons">&#xE8B6;</i>
        </span>
      </p>
      <transition name="fade">
        <div class="control" v-if="userId && userId.length > 0">
          <a class="button" @click="goToDetail()">
            <span class="icon is-small">
              <i class="material-icons">&#xE5C8;</i>
            </span>
          </a>
        </div>
      </transition>
    </div>
    <audience-filter-selector v-if="isFilterActive" @close-filter="toggleFilter()"/>
  </div>
</template>

<script>
import AudienceFilterSelector from "./AudienceFilterSelector";
import { mapState } from "vuex";

export default {
  name: "AudienceFilter",

  components: {
    AudienceFilterSelector
  },

  computed: {
    ...mapState("audience", ["filters"]),
    filtersCount() {
      return this.filters.length;
    }
  },

  data() {
    return {
      userId: null,
      isFilterActive: false,
      hasFocus: false
    };
  },

  deactivated() {
    this.userId = null;
  },

  methods: {
    toggleFilter() {
      this.isFilterActive = !this.isFilterActive;
      this.$emit("audience-filter-toggle", this.isFilterActive);
    },

    goToDetail() {
      this.$router.push({
        name: "audience-user",
        params: { userId: this.userId }
      });
    },

    onFocus() {
      this.hasFocus = true;
    },

    onFocusOut() {
      this.hasFocus = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~scss/utilities/initial-variables.scss";
@import "~scss/utilities/derived-variables.scss";

.audience-filter {
  position: relative;
  display: flex;
  height: 2.5rem;
}

.button-filter-selector {
  background-color: transparent;
  padding: 0.6875rem 1.125rem;
  font-size: 0.6875rem;
  line-height: 1.125rem;
  letter-spacing: 2.3px;
  text-transform: uppercase;
  border-radius: 0;
  // color: rgba($white, .64);

  color: rgba($black, 0.87);
  border-left: 1px solid rgba($black, 0.08);
  border-right: 1px solid rgba($black, 0.08);

  &:hover,
  &:active,
  &:focus {
    // color: rgba($white, .64);
    color: rgba($black, 0.87);
  }

  .tag {
    // background-color: $white;
    // color: rgba($black, .72);
    // border: 1px solid rgba($black, .08);
    background-color: $blue;
    color: $white;
    border: 1px solid $blue;
    height: 1.125rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    margin-left: 0.375rem;
    transition: $transition;
    letter-spacing: initial;
  }

  .icon {
    font-size: 0.875rem;

    &:first-child {
      &:not(:last-child) {
        margin-left: 0;
      }
    }

    &:last-child {
      &:not(:first-child) {
        margin-right: 0;
      }
    }
  }
}

.control {
  &.has-icons-left {
    .input {
      padding-left: 2.125rem;
    }

    .icon {
      height: 2.5rem;

      i {
        font-size: 0.875rem;
        // color: rgba($white, .4);
        color: rgba($black, 0.4);
      }
    }
  }
}

.field {
  &.has-addons {
    .control {
      &:first-child {
        .input {
          border-radius: 0;
        }
      }

      &:last-child {
        .button {
          border-radius: 0;
        }
      }

      &:not(:last-child) {
        margin-right: 0;
      }
    }
  }
}

.field-user-search {
  .input {
    border-right: 1px solid rgba($black, 0.04);
  }

  .button {
    padding: 0.75rem 1.1875rem;
    // background: rgba($white, .2);
    background: $blue;
    border: 0;

    .icon {
      // color: rgba($white, .87);
      color: $white;

      i {
        font-size: 0.875rem;
        line-height: 1.29;
      }
    }
  }
}

.input {
  width: 20rem;
  height: 2.5rem;
  // background: linear-gradient(#313131, #282828);
  // color: rgba($white, .87);
  border: 0;
  box-shadow: none;
  font-size: 0.875rem;
  border-radius: 0;

  background-color: #f5f5f5;
  color: rgba($black, 0.64);

  &::placeholder {
    font-size: 0.6875rem;
    font-weight: $weight-medium;
    letter-spacing: 2.3px;
    // color: rgba($white, .4);
    color: rgba($black, 0.4);
    text-transform: uppercase;
  }

  &:focus,
  &:active {
    box-shadow: none;
  }
}
</style>

